module.exports = __webpack_public_path__ + "static/img/__9248.a03001b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__9248.jpg
// module id = WRaX
// module chunks = 0